import { Helmet } from 'react-helmet'
import Header from '../../../../Components/Header'
import MainContent from './MainContent'
function Contact() {
  return (
    <div className='d-flex flex-column' style={{minHeight:'99.7vh'}}>
      <Helmet>
				<title>Contact List</title>
			</Helmet>
      <Header />
    <MainContent />
    {/* <Footer /> */}
    </div>
  )
}

export default Contact
